import React from 'react';
import PassportSeriesInput from './PassportSeriesInput';
import ChildBirthSertificateSeries2002Input from './ChildBirthSertificateSeries2002Input';
import ChildBirthSertificateSeriesInput from './ChildBirthSertificateSeriesInput';
import ResidenceCertificateSeriesInput from './ResidenceCertificateSeriesInput';
import AnyDocSeriesInput from './AnyDocSeriesInput';
import NullInput from '../NullInput';

export default function DocSeriesInput(props) {
  switch (props.doctype) {
    case 1:
    case '1':
      // паспорт зразка 1993 року
      return <PassportSeriesInput {...props} />;
    // case 2:
    // case '2':
    //   // паспорт зразка 2016 року
    //   return <UniqueRegisterSeriesInput {...props} />;
    case 3:
    case '3':
      // свідоцтво про народження дитини
      return <ChildBirthSertificateSeries2002Input {...props} />;
    case 5:
    case '5':
    case 6:
    case '6':
      // свідоцтво про народження дитини
      return <ChildBirthSertificateSeriesInput {...props} />;
    case 4:
    case '4':
      // тимчасове посвідчення на проживання
      return <ResidenceCertificateSeriesInput {...props} />;
      
    case 99:
    case '99':
      // інший документ
      return <AnyDocSeriesInput {...props} />;
    default:
      return <NullInput {...props} />;
  }
}
